import React, { useRef } from 'react';
import classNames from 'classnames';
import { useResponsiveAnimation } from '../catering-landing-utils';

export const CateringPackageSlide = ({ coverImage, name, subtext, description }) => {
  const cardRef = useRef(null);
  const animate = useResponsiveAnimation(cardRef);

  return (
    <div className="catering-landing-package-slide" ref={cardRef}>
      <div className="catering-landing-package-slide-image-container relative">
        <img src={coverImage} alt={name} />
        <div className={classNames('no-margin h4 package-slide-description-card tw-rounded-4', { active: animate })}>
          {description}
        </div>
      </div>
      <div className="margin-lg-top">
        <p className="tw-body-2-m no-margin" style={{ marginBottom: '2px' }}>
          {name}
        </p>

        <p className="tw-body-1 no-margin" style={{ marginBottom: '6px' }}>
          {subtext}
        </p>
      </div>

    </div>
  );
};
